import { Row, Col, Tooltip } from 'antd'
import { ClearOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'

import SearchInput from './form/SearchInput'
import SelectDropdown from './form/Select'
import RadioGroup from './form/RadioGroup'
import RangePicker from './form/RangePicker'

const Filters = ({ inputs, hideClearFilters }) => {
  const history = useHistory()
  const location = useLocation()

  // Compute a key that changes when route query or inputs change
  const remountKey = useMemo(() => {
    // JSON.stringify(inputs) is used so that changes to inputs prop will also remount
    return `${location.pathname}|${location.search}|${JSON.stringify(inputs)}`
  }, [location.pathname, location.search, inputs])

  // Function to render input based on type
  const renderInput = (input) => {
    switch (input.type) {
      case 'SEARCH':
        return <SearchInput {...input} />
      case 'SELECT':
        return <SelectDropdown isFilter={true} {...input} />
      case 'RADIO':
        return <RadioGroup isFilter={true} {...input} />
      case 'RANGE_PICKER':
        return <RangePicker />
      // Add cases for other types as needed
      default:
        return null
    }
  }

  const resetQueryParams = () => {
    history.push({
      pathname: history.location.pathname,
    })
  }

  return (
    <div className='d-flex align-items-start gap-3'>
      <Row key={remountKey} gutter={[24, 24]} className='w-100' id='main-form-style'>
        {inputs.map((input, index) => (
          <Col key={index} span={input.span}>
            {renderInput(input)}
          </Col>
        ))}
      </Row>
      <Tooltip title='Clear filters'>
        <ClearOutlined
          className={`cursor-pointer py-3 ${hideClearFilters ? 'd-none' : ''}`}
          onClick={resetQueryParams}
        />
      </Tooltip>
    </div>
  )
}

export default Filters
